import React, { useContext } from "react";
import { MainContext } from "../../context/MainContext";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";

import ToggleOnOutlinedIcon from "@mui/icons-material/ToggleOnOutlined";
import ToggleOffOutlinedIcon from "@mui/icons-material/ToggleOffOutlined";

function makeTile(dip, label, value) {
  const isOn = value === "On";

  const tileBg = isOn
    ? "rgba(76,175,80,0.20)"
    : "rgba(255,255,255,0.04)";

  const borderColor = "rgba(255,255,255,0.1)";

  const iconBg = isOn
    ? "rgba(76,175,80,0.9)"
    : "rgba(255,255,255,0.12)";

  const iconColor = isOn ? "#000" : "rgba(255,255,255,0.7)";

  const chipStyles = isOn
    ? {
        bgcolor: "rgba(76,175,80,0.15)",
        border: "1px solid rgba(76,175,80,0.5)",
        color: "#4CAF50",
      }
    : {
        bgcolor: "rgba(244,67,54,0.15)",
        border: "1px solid rgba(244,67,54,0.4)",
        color: "#F44336",
      };

  return {
    dip,
    label,
    value,
    tileBg,
    borderColor,
    iconBg,
    iconColor,
    chipStyles,
  };
}

export default function HPDashboardDips() {
  const state = useContext(MainContext).state;
  const re = state.RE.split(",");

  const dips = [
    { dip: "1", label: "EEV", bit: 0x01 },
    { dip: "2", label: "EVI", bit: 0x02 },
    { dip: "3", label: "Pump", bit: 0x04 },
    { dip: "4", label: "", bit: 0x08 },
    { dip: "5", label: "", bit: 0x10 },
    { dip: "6", label: "", bit: 0x20 },
  ];

  const tiles = dips.map((d) => {
    const isOn = (re[63] & d.bit) === d.bit;
    return makeTile(d.dip, d.label, isOn ? "On" : "Off");
  });

  return (
    <React.Fragment>
      <Typography
        component="h2"
        variant="h6"
        color="white"
        gutterBottom
        sx={{ fontWeight: 600 }}
      >
        DIP Switches
      </Typography>

      <Grid container spacing={1.5}>
        {tiles.map((item) => (
          <Grid item xs={6} sm={4} md={6} key={item.dip}>
            <Paper
              sx={{
                p: 1.3,
                height: 85,
                display: "flex",
                alignItems: "center",
                gap: 1.2,
                borderRadius: 2,
                bgcolor: item.tileBg,
                border: `1px solid ${item.borderColor}`,
                transition: "0.2s ease",
                "&:hover": {
                  transform: "translateY(-2px)",
                  bgcolor:
                    item.value === "On"
                      ? "rgba(76,175,80,0.30)"
                      : "rgba(255,255,255,0.08)",
                },
              }}
            >
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: item.iconBg,
                  color: item.iconColor,
                  flexShrink: 0,
                }}
              >
                {item.value === "On" ? (
                  <ToggleOnOutlinedIcon />
                ) : (
                  <ToggleOffOutlinedIcon />
                )}
              </Box>

              <Box sx={{ flexGrow: 1 }}>
                <Typography
                  variant="subtitle2"
                  color="white"
                  sx={{ fontSize: 13, fontWeight: 600 }}
                >
                  DIP {item.dip}
                </Typography>

                {item.label && (
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      color: "rgba(255,255,255,0.5)",
                      fontSize: 11,
                      mb: 0.3,
                    }}
                  >
                    {item.label}
                  </Typography>
                )}

                <Chip
                  label={item.value}
                  size="small"
                  sx={{
                    height: 20,
                    fontSize: "11px",
                    fontWeight: 600,
                    borderRadius: "6px",
                    ...item.chipStyles,
                  }}
                />
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </React.Fragment>
  );
}
